import Vue from 'vue'
import VueRouter from 'vue-router'

const login = () => import('../page/LoginModule/LoginPage');
const home = () => import('../page/HomeMoudule/HomePage');
const trade = () => import('../page/TradeMoudule/TradePage');
const detail = () => import('../page/DetailPageMoudule/DetailPage');

Vue.use(VueRouter);


const router = new VueRouter({
    routes: [
        {
            name: 'login',
            path: '/login', component: login,
            meta: {
                title: "股票交易端"
            }
        }, {
            path: '/', component: home,
            meta: {
                title: "股票交易端"
            },
            children: [{
                path: '/', redirect: '/trade/0', alias: '/trade',
            },{
                name: 'trade',
                path: 'trade/:id', component: trade,
                meta: {
                    title: "股票交易端"
                },
            },{
                name: 'detail',
                path: '/detail/:type', component: detail,
                meta: {
                    title: "股票交易端"
                }
            }]
        }
    ]
});

// 验证登录信息
const localLogin = function() {
    return new Promise(resolve => {
        resolve(sessionStorage.getItem('trade_account') && sessionStorage.getItem('token'));
    })
};

// 路由守卫
router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    let isLogin = localLogin();
    if (title) {
        document.title = title;
    }
    if(to.name === 'update') {
        next();
    } else if (to.name === 'login') {
        isLogin.then(e => {
            if(e) {
                next('/');
            } else {
                next();
            }
        });
    } else {
        isLogin.then(e => {
            if(e) {
                next();
            } else {
                next('/login');
            }
        });
    }
});

export {
    router
}
